import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const CAMPAIGNS_CAMPAIGN_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/campaigns',
        iconClass: 'fas fa-hand-holding-medical',
        name: '::Menu:Campaigns',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.Campaigns',
      },
    ]);
  };
}
